import { Config } from '@vk-ecosystem/sdk';

import { getAutologinRedirect } from '../utils';

import { widgetEnableVkIdAutologin, widgetVkIdAppKey } from '../../config';

export const useInitVkId = (widgetUuid?: string) => {
  if (widgetEnableVkIdAutologin === 'true') {
    Config.init({
      appId: Number(widgetVkIdAppKey),
    });

    if (widgetUuid) {
      getAutologinRedirect(widgetUuid);
    }
  }
};
